(ns common.select-util
  (:require [clojure.string :as string]
            [common.util :as cu]))

(defn parse-str
  ([str-value lower-case-options-lookup]
   (parse-str str-value lower-case-options-lookup false false))
  ([str-value lower-case-options-lookup multi?]
   (parse-str str-value lower-case-options-lookup multi? false))
  ([str-value lower-case-options-lookup multi? trim?]
   (let [lc-value (if trim?
                    (cu/str-trim-lcase str-value)
                    (string/lower-case str-value))]
     (if multi?
       {:parsed-value (->> (string/split ";" lc-value)
                           (keep (fn [opt]
                                   (:parsed-value (parse-str opt lower-case-options-lookup false false)))))}
       {:parsed-value (get lower-case-options-lookup lc-value str-value)}))))

(defn resolve-value
  [native-value lower-case-options-lookup multi?]
  (if-not multi?
    {:parsed-value (if-let [v (when (map? native-value)
                                (:value native-value))]
                     v
                     (get lower-case-options-lookup native-value native-value))}
    {:parsed-value (if-not (coll? native-value)
                     (get lower-case-options-lookup native-value native-value)
                     (->> native-value
                          (keep (fn [single-value]
                                  (let [single (resolve-value single-value lower-case-options-lookup false)]
                                    (:parsed-value single))))
                          (doall)
                          (seq)))}))

(def test-atom (atom {}))
(defn parse-value
  [native-value lower-case-options-lookup multi?]
  (let [parse-meta (if (string? native-value)
                     (parse-str native-value lower-case-options-lookup multi?)
                     (resolve-value native-value lower-case-options-lookup multi?))
        res (:parsed-value parse-meta)]
    (reset! test-atom {:native-value native-value
                       :lookup       lower-case-options-lookup})
    res))

(defn value-opt
  [value options]
  (if (and (map? value)
           (contains? value :value))
    value
    (->> options
         (cu/filter-by :value value)
         (first))))


(defn value-to-opt
  [is-multi? value options]
  (if is-multi?
    (->> value
         (mapv (fn [v]
                 (value-opt v options))))
    (value-opt value options)))
